<template>
    <v-layout class="login-wrapper" column>
        <login-server-error v-if="showServerError"></login-server-error>
        <!--email step-->
        <div class="step" v-if="step === 'email'" align-center justify-space-around column fill-height >
            <v-layout v-if="!showServerError" align-center justify-center class="description email">
                {{$t('common.login.enter_your_email')}}
            </v-layout>
            <v-form ref="emailForm" v-on:submit.enter.prevent>
                <v-layout class="email-input-wrapper" wrap>
                    <v-flex>
                        <v-text-field v-model="email"
                                      @keyup.enter.prevent="sendCode"
                                      :error-messages="emailError"
                                      :label="$t('common.login.email')"
                                      required></v-text-field>
                    </v-flex>
                </v-layout>
                <v-btn depressed text
                       :disabled="!validatedEmailRules"
                       :style="btnStyles"
                       :loading="inProgress"
                       @click="sendCode(false)">{{$t('common.login.send_me_a_code')}}</v-btn>
            </v-form>
        </div>
        <!--end of email step-->

        <!--code step-->
        <div class="step" v-else align-center justify-space-around column fill-height >
            <v-layout v-if="!showServerError" align-center justify-center column class="description">
                <span class="first-row">{{$t('common.login.enter_verification_code')}}</span>
                <span class="second-row">{{codeSentByText}}</span>
            </v-layout>
                <v-form v-on:submit.prevent v-model="codeValid" ref="codeForm">
                    <v-layout id="input-wrapper" wrap>

                        <v-flex>
                            <v-text-field
                                v-model="code"
                                @keyup.enter.prevent="loginWithCode"
                                maxlength="6"
                                onpaste="resetCodeError"
                                @keyup="resetCodeErrorPaste"
                                :rules="codeRules"
                                :label="$t('common.login.enter_code')" required></v-text-field>
                            <div class="invalid-code-error" v-if="codeError && codeValid">{{$t('common.login.code_is_invalid')}} <span @click="sendCode(false)">{{$t('common.login.get_new_code')}}</span></div>
                        </v-flex>
                    </v-layout>
                    <v-layout id="button-wrapper" column>
                      <v-btn
                        depressed flat
                        :loading="inProgress"
                        class="login"
                        :disabled="code.length < 6 || code.replace(/[\d]/igm,'').length > 0 || codeError"
                        :style="btnStyles"
                        @click="loginWithCode">{{$t('common.login.login')}}</v-btn>
                      <div class="back-button-wrapper">
                        <span @click="backToEmail" class="back-button">{{$t('common.login.back_to_reenter_email')}}</span>
                      </div>
                    </v-layout>
                </v-form>
            <v-layout v-if="codeSentBy == 'sms'" class="didnt-get-code" column>
                <div>{{$t('common.login.didnt_get_sms')}}</div>
                <div class="second-row">
                    <span>{{$t('common.login.no_worries_1')}}</span>
                    <span @click="sendCode(true)" class="click-here">{{$t('common.login.no_worries_2')}}</span>
                    <span>{{$t('common.login.no_worries_3')}}</span>
                </div>
            </v-layout>
        </div>
        <!--end of code step-->

    </v-layout>
</template>

<script>
    import {authService} from '@/modules/auth/services/authService.js'
    import CustomValidation from "@/modules/auth/services/customValidationService";
    import LoginServerError from "./LoginServerError";

    import { mapActions, mapGetters } from "vuex";

    export default {
        name: 'LoginWithCode',
        components: {LoginServerError},
        data: function () {
            return {
                codeValid:false,
                step: 'email',
                inProgress: false,
                codeSentBy: '',
                codeSentByText: '',
                email: '',
                phoneNumber: '',
                showServerError: false,
                emailError: '',
                codeError: false,
                code: '',
                bthBackground: '',
                bthTextColor: '',
                emailRules: CustomValidation.validateEmail(this.$t('common.login.please_enter_a_valid_email'))

            }
        },
        methods: {
            resetCodeError(e){
                if(e.keyCode >= 48 && e.keyCode <= 57 || e.keyCode >= 96 && e.keyCode <= 105){
                    this.codeError= false
                }
            },
            resetCodeErrorPaste(){
                this.codeError= false
            },
            async sendCode(force_email) {
                this.inProgress = true
                this.showServerError = false
                this.codeError = false
                this.code = ''
                let result = await authService.getLoginCode({email: this.email,force_email: force_email})

                if (result){
                    if (result.success === false) {
                      if(result.error === 'invalid_credentials'){
                        // can't tell the user the email doesn't exist, fake a sent email
                        this.step = 'code'
                        this.emailError = ''
                        this.codeSentBy = 'email'
                        this.codeSentByText = this.$t('common.login.code_was_sent_by_email', {'email':this.email})
                      }
                      else if(result.error === 'server_error'){
                        this.showServerError = true
                      }
                    }
                    if (result.success === true){
                        this.step = 'code'
                        this.emailError = ''
                        this.codeSentBy = result.data.sent
                        this.phoneNumber= result.data.number
                        this.codeSentByText = result.data.sent == 'email' ? this.$t('common.login.code_was_sent_by_email',{'email':this.email}) : this.$t('common.login.code_was_sent_by_sms',{'number':this.phoneNumber})
                    }
                }
                this.inProgress = false
            },
            async loginWithCode (force_email){
                this.inProgress = true
                this.codeError = false
                if (this.$store.getters.vcitaWindowLocation) {
                  this.$track('Login Click', {'Info': 'Popup', 'Page': 'App Login','Platform': this.$store.getters.platform, 'Origin': 'App Login with Code Form'})
                }
                if( this.$refs.codeForm.validate() ){
                    let result = await authService.login({code: this.code,email: this.email})
                    if(result && result.success === false){
                        if(result.error === 'invalid_credentials'){
                            this.codeError = true
                        }else if(result.error === 'server_error'){
                            this.showServerError = true
                        }
                        this.inProgress = false
                    } else this.$track('Login success', {'Info': 'Popup', 'Page': 'App Login','Platform': this.$store.getters.platform, 'Type': 'code', 'Origin': 'Password Form'})
                }
            },
          backToEmail() {
              this.step = 'email'
          }

        },
        computed: {
            ...mapGetters("brandModule", ["branding"]),
            validatedEmailRules() {
                    return this.emailRules.every(func => (func(this.email) === true));
            },
            codeRules() {
                return [
                    v => v.replace(/[\d]/igm,'').length === 0 || this.$t('common.login.enter_numbers_only')
                ]
            },
            btnStyles(){
                if((this.step == 'code' && this.code.length < 6 || this.code.replace(/[\d]/igm,'').length > 0 || this.codeError) || (this.step == 'email' && !this.validatedEmailRules)){
                  return this.disabledBtnStyle
                }
                return this.enabledBtnStyle
            },
            disabledBtnStyle() {
              return ({
                backgroundColor: '#e4e4e4',
                color: '#afafaf'
              })
            },
            enabledBtnStyle() {
              return({
                backgroundColor: this.branding.secondary_color,
                color: this.branding.text_color
              })
            }
        }
    }
</script>


<style scoped lang="scss">
@import "@/assets/scss/abstract/_variables.scss";

    .login-wrapper{
        font-family: var(--font3);
        height: 100%;

        form{
            margin-top: 0px;
        }
    }

    .v-btn{
        margin-top: 30px;
    }

    .back-button-wrapper{
      margin-top: 5px;
      margin-bottom: 26px;
      height: 18px;
    }

    .step{
        height: 100%;
    }

    .code-input{
        margin-bottom: 4px;
        font-family: var(--font3);
    }

    .invalid-code-error{
        height: 34px;
        margin-top: -16px;
    }

    .description{
        width: 87%;
        margin: 20px auto 12px auto;
        text-align: center;
        font-size: 15px;
        font-family: var(--font3);

        &.email{
            margin: 30px auto 12px auto;
        }

        .first-row{
            font-family: var(--font2);
            font-size: 22px;
            font-weight: 600;
            color: #333333;
        }

        .second-row{
            width: 100%;
        }
    }

    .invalid-code-error{
        color: #ff5252;
        font-size: 12px;

        span{
            color: $linkColor;
            cursor: pointer;
            z-index: 99;
            position: relative;
        }
    }

    #email-wrapper{
        margin-top: 18px;
    }

    .didnt-get-code{
        width: 100%;
        font-size: 14px;
        margin-top: 31px;
        cursor: pointer;
        font-family: var(--font3);
        color: rgba(51, 51, 51, 0.87);

        .second-row{
            color: #999999;

            .click-here{
                color:$linkColor;
                margin: 0px 5px
            }
        }
    }

</style>
